import React, {ReactChild} from 'react';
import {ThemeProvider} from "styled-components";

interface ThemeContextProviderProps {
    primary: string | undefined,
    secondary: string | undefined,
    children: ReactChild
}

const ThemeContextProvider = ({children, primary, secondary}: ThemeContextProviderProps) => {
    return (
        <ThemeProvider theme={{primary: primary, lightPrimary: secondary}}>
            {children}
        </ThemeProvider>
    )
};

export default ThemeContextProvider;
